import { useCallback, useEffect, useMemo, useRef } from "react";

import { defaultKSK2080_R01Filter, KSK2080_R01Filter, useKSK2080_R01Store } from "./Store_KSK2080_R01";
import useUiuxStore from "src/store/useUiuxStore";

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { refetchUpdateList } from "src/utils/axios/reFetch";
import { formatDate, validateString } from "src/utils/string/stringUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { createKSK2080_R01, deleteKSK2080_R01, downloadExcel_KSK2080_R01, getKSK2080_R01AllCount, getKSK2080_R01List, getKSK2080_R01One, patchKSK2080_R01 } from "./Api_KSK2080_R01";
import { defaultKSK2080_R01Dto, KSK2080_R01Dto } from "./Dto_KSK2080_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from "src/utils/grid/GridHandlerContent";

interface Props {
	gridRef: React.RefObject<AgGridReact<KSK2080_R01Dto> | null>;
	containerRef: React.RefObject<HTMLDivElement | null>;
	
}

export const Content_KSK2080_R01 = (props: Props) => {

	const {
		gridRef,
		containerRef,
		
	} = props;

	useFetchActionbarAuth("KSK2080_R01");
	const { setLoadingSpinner } = useLoadingSpinnerStore();

	
	const { 
		
		KSK2080_R01List, setKSK2080_R01List, 
		selectedKSK2080_R01,  setSelectedKSK2080_R01, 
		editKSK2080_R01, setEditKSK2080_R01, 
		allCount, setAllCount,
		initData,
		} = useKSK2080_R01Store();

	const { 
		KSK2080_R01Filter, setKSK2080_R01Filter,
		KSK2080_R01PastFilter, setKSK2080_R01PastFilter,
	 } = useKSK2080_R01Store();
	const { setMessage } = useUiuxStore();
	const isResizing = useRef(true);

	const handleExcelClick = useCallback(async () => {
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK2080_R01(
			'',
			getParams(KSK2080_R01Filter),
			KSK2080_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '품목 정보등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [KSK2080_R01Filter, KSK2080_R01List, setLoadingSpinner])

	const getParams = (filter: Partial<KSK2080_R01Filter>) => {
		return {
			dateRange: filter.dateRange,
			startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
			endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		}
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getKSK2080_R01AllCount(getParams(KSK2080_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [KSK2080_R01Filter])

	const defaultKSK2080_R01Row = useMemo(() => {
		return {
			...defaultKSK2080_R01Dto,
			inserted: true,
		}
	}, [defaultKSK2080_R01Dto])

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);

		const response = await getKSK2080_R01List(
			'search',
			getParams(KSK2080_R01Filter),
			KSK2080_R01List.length ?? 0
		);
		let newList = [...response.data.data] as KSK2080_R01Dto[];
		setKSK2080_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedKSK2080_R01,
				() => true,// () => !newList.find(value => value.itemCd === selectedKSK2080_R01?.itemCd)
			);
			setKSK2080_R01PastFilter(KSK2080_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('조회된 데이터가 없습니다.');
		}
		setLoadingSpinner(false);

		return response.data.data;
	}, [KSK2080_R01Filter, KSK2080_R01List, gridRef, editKSK2080_R01, setKSK2080_R01List, setSelectedKSK2080_R01, ])

	const fetchOne = useCallback(async () => {
		if (!selectedKSK2080_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getKSK2080_R01One(selectedKSK2080_R01.noticeNo);
			setEditKSK2080_R01({ ...defaultKSK2080_R01Row, ...response.data.data });
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedKSK2080_R01])

	const initContainerData = useCallback(() => {
		initData();
	}, [setKSK2080_R01List, setSelectedKSK2080_R01, setEditKSK2080_R01, defaultKSK2080_R01Row])

	const handleCreateClick = useCallback(async () => {
		initNoticeData();
	}, []);

	const handleDeleteClick = useCallback(async () => {
		if (!selectedKSK2080_R01) {
			showWarning('선택된 품목이 없습니다.'); return;
		}
		if (window.confirm('정말로 삭제하시겠습니까?')) {
			await deleteKSK2080_R01(selectedKSK2080_R01.noticeNo);
			refetchUpdateList('delete', selectedKSK2080_R01, selectedKSK2080_R01, 'noticeNo', KSK2080_R01List, setKSK2080_R01List);
			handleCreateClick();
			showSuccess(`${selectedKSK2080_R01.noticeNo} 공지사항 삭제가 완료되었습니다.`)
		}

	}, [selectedKSK2080_R01])

	const validateInsertData = (data: KSK2080_R01Dto) => {

		if (!validateString(data.noticeNo)) {
			showWarning("품목코드를 입력하세요."); return false;
		}

		return true;
	}

	const handleSaveClick = useCallback(async () => {

		if (!editKSK2080_R01) {
			showWarning("품목을 선택하세요."); return;
		}
		if (!validateInsertData(editKSK2080_R01)) return;

		let processName = '';
		let responseData: KSK2080_R01Dto = { ...defaultKSK2080_R01Dto };
	
		if (selectedKSK2080_R01) {
			processName = 'patch';
			const response = await patchKSK2080_R01(editKSK2080_R01);
			responseData = response.data.data[0];
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${editKSK2080_R01.noticeNo} 공지사항 수정이 완료되었습니다.`);
					setMessage(`${editKSK2080_R01.noticeNo} 공지사항 수정이 완료되었습니다.`);
				}else return;
			}
		} else {
			processName = 'post';
			const response = await createKSK2080_R01(editKSK2080_R01);
			responseData = response.data.data[0];
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${editKSK2080_R01.noticeNo} 공지사항 등록이 완료되었습니다.`);
					setMessage(`${editKSK2080_R01.noticeNo} 공지사항 등록이 완료되었습니다.`);
				}else return;
			}
		}
	
		setTimeout(() => {
			setMessage("");
		}, 5000)
		if(editKSK2080_R01) {
			refetchUpdateList(processName, responseData, editKSK2080_R01, 'noticeNo', KSK2080_R01List, setKSK2080_R01List);
			// console.log('handleSaveClick responseData : ', responseData);
			setSelectedKSK2080_R01(responseData);
		}
		
	}, [editKSK2080_R01, selectedKSK2080_R01])
	
	const initNoticeData = () => {
		setSelectedKSK2080_R01(undefined);
		setEditKSK2080_R01(defaultKSK2080_R01Row);
	}

	//selectedKSK2080_R01 변경 시 품목 이미지 불러오기
	useEffect(() => {
		if (selectedKSK2080_R01) {
			fetchOne();
		}
	}, [selectedKSK2080_R01])

	//처음 페이지 오픈시 조회 시작
	useEffect(() => {
		fetchData();
	}, [])

	return {
		handleExcelClick,
		defaultKSK2080_R01Row,
		fetchData,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	}
}
